export default __webpack_public_path__ + "static/media/approved.513a8565.svg";